import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
    name: string;
    phone: string;
    isAdmin: boolean;
    isSuperAdmin?: boolean;
    token: string;
}

export interface UserStore {
    user: User | null;
    setUser: (user: User) => void;
    clearUser: () => void;
}

export const useUserStore = create<UserStore>()(
    persist(
        (set) => ({
            user: null,
            setUser: (user: User) => set({ user }),
            clearUser: () => set({ user: null }),
        }),
        {
            name: 'user-storage', // Ключ для localStorage
        }
    )
);
